<res-base-modal
    [modalTitle]="modalTitle" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId" 
    [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="save()" [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()"
    [secondaryButtonLabel]="secondaryButtonLabel" (closeButtonActionEmt)="closeModal()"
    [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage" 
    [buttonTemplate]="validateButtonTemplate" [modalHelpIndex]="modalHelpIndex">

    <form class="content" #contentForm="ngForm" >
        <res-name-description [isNameDisabled]="isInEditMode" [automationId]="modalAutomationId" [validateName]="true" [customLabelWidth]="105"
                              [validateNameRequest]="validateNameRequest" [name]="exportDb.name" [description]="exportDb.description">
        </res-name-description>     
        <div class="modal-row">
            <div class="modal-row-column-auto group-label">
                <label for="typeInput">Type:</label>
            </div>
            <div class="modal-row-column-auto type">
                <label [attr.data-automation-id]="modalAutomationId + '-type-label'">MS SQL</label>
            </div>
        </div>
        <div class="modal-row">
            <div class="modal-row-column-auto group-label">
                <label for="ipInput" requiredAsterisk>IP:
                </label>
            </div>
            <div class="modal-row-column-max">
                <input required id="ipInput" name="ip" type="text" [(ngModel)]="exportDb.ipAddress" [attr.data-automation-id]="modalAutomationId + '-ip-input'"
                />
            </div>
        </div>
        <div class="modal-row">
            <div class="modal-row-column-auto group-label">
                <label for="portInput">Port:</label>
            </div>
            <div class="modal-row-column-max">
                <input id="portInput" type="text" name="port" [(ngModel)]="exportDb.port" [attr.data-automation-id]="modalAutomationId + '-port-input'"
                />
            </div>
        </div>
        <div class="modal-row">
            <div class="modal-row-column-auto group-label">
                <label for="dbNameInput" requiredAsterisk >Database Name:
                </label>
            </div>
            <div class="modal-row-column-max">
                <input required id="dbNameInput" type="text" name="dbName" [(ngModel)]="exportDb.databaseName" [attr.data-automation-id]="modalAutomationId + '-database-name-input'"
                />
            </div>
        </div>
        <div class="modal-row">
            <div class="modal-row-column-auto group-label">
                <label for="usernameInput" requiredAsterisk >Username:
                </label>
            </div>
            <div class="modal-row-column-max">
                <input required id="usernameInput" type="text" name="username" [(ngModel)]="exportDb.username" [attr.data-automation-id]="modalAutomationId + '-username-input'"
                />
            </div>
        </div>
        <div class="modal-row">
            <div class="modal-row-column-auto group-label">
                <label for="passwordInput" requiredAsterisk >Password:
                </label>
            </div>
            <div class="modal-row-column-max">
                <input required id="passwordInput" type="password" name="password" class="password-input" [(ngModel)]="exportDb.password"
                    [attr.data-automation-id]="modalAutomationId + '-password-input'" />
            </div>
        </div>
    </form>
    <ng-template #validateButtonTemplate>
        <button type="button" [attr.data-automation-id]="modalAutomationId + '-validate-button'" class="secondary-button validate-button"
            (click)="validate()" [disabled]="!isValidateEnabled()">
            <i class="fa fa-check fa-icon sizing-icons"></i>Validate</button>
    </ng-template>
</res-base-modal>